const messages = {
  en: {
    loadingEvents: 'Loading events...',
    events: 'Events',
    myTickets: 'My Tickets',
    myOrders: 'My Orders',
    dashboard: 'Dashboard',
    logout: 'Logout',
    login: 'Login',
    signUp: 'Sign Up',
    profile: 'Profile',
    discover: 'Discover and book events.',
    customers: 'Customers',
    browseEvents: 'Browse events',
    terms: 'Terms and conditions',
    privacy: 'Privacy policy',
    organizers: 'Organizers',
    organizerPortal: 'Organizer portal',
    talenciaBlurb: 'For organizers who need talent.',
    camupBlurb: 'Store and share securely photos with face recognition.',
    contact: 'Contact',
    phoneWhatsapp: 'Phone and WhatsApp',
    tapToReveal: 'Tap to reveal',
    rights: 'All rights reserved.',
    searchEvents: 'Search event or location',
    today: 'Today',
    tomorrow: 'Tomorrow',
    weekend: 'This Weekend',
    chooseDate: 'Choose a date',
    allEvents: 'All Events',
    eventsFound: '{count} events found',
    noEvents: 'No events found',
    noEventsHint: 'Try selecting a different category',
    free: 'FREE',
    from: 'From',
    viewEvent: 'View Event & Tickets',
    view: 'View',
    topEvents: 'Top Events',
    featuredEvents: 'Featured Events',
    bestSeller: 'Best Seller',
    newEvent: 'New Event',
    whyTitle: 'Why buy tickets with',
    fastTitle: 'Lightning Fast',
    fastBody: 'Book your tickets in seconds with our streamlined checkout process. No hassle, no delays.',
    digitalTitle: 'Digital Tickets',
    digitalBody: 'Get instant QR code tickets on your phone. Eco-friendly and always accessible.',
    secureTitle: 'Secure Payment',
    secureBody: 'Your transactions are protected with bank-level security and encryption.',
    backHome: 'Back to home',
    backSignIn: 'Back to sign in',
    signIn: 'Sign in',
    signInLead: 'Welcome back. Enter your details to continue.',
    email: 'Email',
    password: 'Password',
    forgot: 'Forgot password?',
    forgotTitle: 'Forgot password',
    forgotLead: 'Enter the email on your Ticketaty account. This page does not send a reset email yet.',
    nothingSent: 'Nothing was sent for {email}. Password reset is not connected to an account service.',
    continue: 'Continue',
    remembered: 'Remembered it?',
    signingIn: 'Signing in…',
    newHere: 'New to Ticketaty?',
    createAccount: 'Create an account',
    createLead: 'Create your Ticketaty account.',
    firstName: 'First name',
    lastName: 'Last name',
    mobile: 'Mobile',
    optional: '(optional)',
    mobileNumber: 'Mobile number',
    confirmPassword: 'Confirm password',
    agreeBefore: 'I agree to the',
    agreeMid: 'and the',
    agreeAfter: 'of Ticketaty.',
    creating: 'Creating account…',
    already: 'Already have an account?',
    myProfile: 'My Profile',
    profileLead: 'Your Ticketaty account details.',
    profileInfo: 'Profile information',
    emailLocked: 'Email cannot be changed.',
    updating: 'Updating…',
    updateProfile: 'Update profile',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNew: 'Confirm new password',
    updatePassword: 'Update password',
    ticketsLead: 'Tickets from your Ticketaty orders.',
    ordersLead: 'Purchases made with your Ticketaty account.',
    searchTitle: 'Search event title',
    orderNo: 'Order #{id}',
    orderedOn: 'Ordered on {date}',
    scannedOn: 'Scanned on {date}',
    viewQr: 'View QR Code',
    ticketsCount: '{count} tickets',
    subtotal: 'Subtotal',
    discount: 'Discount',
    total: 'Total',
    backEvents: 'Back to events',
    starts: 'Starts',
    ends: 'Ends',
    organizedBy: 'Organized by',
    spotsLeft: '{count} spots left',
    eventDetails: 'Event details',
    location: 'Location',
    locationMissing: 'Location coordinates not available',
    category: 'Category',
    seating: 'Seating',
    loadingMap: 'Loading seat map…',
    priceFrom: 'Price from',
    selectTickets: 'Select tickets',
    pleaseWait: 'Please wait…',
    left: '{count} left',
    soldOut: 'Sold out',
    addOn: 'Add-on',
    proceed: 'Proceed to Checkout',
    processing: 'Processing...',
    ticketCount: '{count} tickets',
    ticketOne: '1 ticket',
    chargedIn: 'You will be charged in {currency}.',
    approxRate: 'Approximate, using today’s rate.',
    gaZone: 'GA Zone',
    valet: 'Valet',
    timeLeft: '{time} left',
    spotsLeft: '{count} spots left',
    tapToAdd: 'Tap to add',
    availableCount: '{count} available',
    clickSeats: 'Click to choose seats',
    available: 'Available',
    held: 'Held',
    sold: 'Sold',
    blocked: 'Blocked',
    disabled: 'Disabled',
    operatedBy: 'Operated by {name}, {address}.',
    lastUpdated: 'Last updated 2 October 2026',
    customerTerms: 'Customer terms',
    status_paid: 'Paid',
    status_pending: 'Pending',
    status_failed: 'Failed',
    status_cancelled: 'Cancelled',
    status_refunded: 'Refunded',
  },
  ar: {
    loadingEvents: 'جارٍ تحميل الفعاليات...',
    events: 'الفعاليات',
    myTickets: 'تذاكري',
    myOrders: 'طلباتي',
    dashboard: 'لوحة التحكم',
    logout: 'تسجيل الخروج',
    login: 'دخول',
    signUp: 'إنشاء حساب',
    profile: 'الملف',
    discover: 'اكتشف الفعاليات واحجز تذاكرك.',
    customers: 'العملاء',
    browseEvents: 'تصفح الفعاليات',
    terms: 'الشروط والأحكام',
    privacy: 'سياسة الخصوصية',
    organizers: 'المنظمون',
    organizerPortal: 'بوابة المنظمين',
    talenciaBlurb: 'للمنظمين الذين يحتاجون إلى مواهب.',
    camupBlurb: 'خزّن وشارك الصور بأمان مع التعرف على الوجه.',
    contact: 'التواصل',
    phoneWhatsapp: 'الهاتف وواتساب',
    tapToReveal: 'اضغط للإظهار',
    rights: 'جميع الحقوق محفوظة.',
    searchEvents: 'ابحث عن فعالية أو مكان',
    today: 'اليوم',
    tomorrow: 'غدًا',
    weekend: 'نهاية الأسبوع',
    chooseDate: 'اختر تاريخًا',
    allEvents: 'كل الفعاليات',
    eventsFound: '{count} فعالية',
    noEvents: 'لا توجد فعاليات',
    noEventsHint: 'جرّب فئة أخرى',
    free: 'مجاني',
    from: 'ابتداءً من',
    viewEvent: 'عرض الفعالية والتذاكر',
    view: 'عرض',
    topEvents: 'أبرز الفعاليات',
    featuredEvents: 'فعاليات مميزة',
    bestSeller: 'الأكثر مبيعًا',
    newEvent: 'فعالية جديدة',
    whyTitle: 'لماذا تشتري التذاكر من',
    fastTitle: 'حجز سريع',
    fastBody: 'احجز تذكرتك خلال ثوانٍ عبر خطوات دفع واضحة، بلا تعقيد.',
    digitalTitle: 'تذاكر رقمية',
    digitalBody: 'تصلك تذكرة برمز QR على هاتفك فورًا، وتبقى معك دائمًا.',
    secureTitle: 'دفع آمن',
    secureBody: 'معاملاتك محمية بتشفير بمستوى البنوك.',
    backHome: 'العودة إلى الرئيسية',
    backSignIn: 'العودة لتسجيل الدخول',
    signIn: 'تسجيل الدخول',
    signInLead: 'مرحبًا بعودتك. أدخل بياناتك للمتابعة.',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    forgot: 'نسيت كلمة المرور؟',
    forgotTitle: 'نسيت كلمة المرور',
    forgotLead: 'أدخل البريد المسجّل في حسابك على تيكيتاتي. هذه الصفحة لا ترسل رسالة إعادة تعيين بعد.',
    nothingSent: 'لم يُرسل شيء إلى {email}. إعادة تعيين كلمة المرور غير مربوطة بخدمة الحسابات.',
    continue: 'متابعة',
    remembered: 'تذكّرتها؟',
    signingIn: 'جارٍ الدخول…',
    newHere: 'جديد على تيكيتاتي؟',
    createAccount: 'إنشاء حساب',
    createLead: 'أنشئ حسابك على تيكيتاتي.',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    mobile: 'الجوال',
    optional: '(اختياري)',
    mobileNumber: 'رقم الجوال',
    confirmPassword: 'تأكيد كلمة المرور',
    agreeBefore: 'أوافق على',
    agreeMid: 'و',
    agreeAfter: 'الخاصة بتيكيتاتي.',
    creating: 'جارٍ إنشاء الحساب…',
    already: 'لديك حساب؟',
    myProfile: 'ملفي',
    profileLead: 'بيانات حسابك على تيكيتاتي.',
    profileInfo: 'بيانات الملف',
    emailLocked: 'لا يمكن تغيير البريد الإلكتروني.',
    updating: 'جارٍ التحديث…',
    updateProfile: 'تحديث الملف',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmNew: 'تأكيد كلمة المرور الجديدة',
    updatePassword: 'تحديث كلمة المرور',
    ticketsLead: 'التذاكر الصادرة من طلباتك على تيكيتاتي.',
    ordersLead: 'المشتريات التي تمت من حسابك على تيكيتاتي.',
    searchTitle: 'ابحث بعنوان الفعالية',
    orderNo: 'طلب #{id}',
    orderedOn: 'تاريخ الطلب {date}',
    scannedOn: 'تم المسح في {date}',
    viewQr: 'عرض رمز QR',
    ticketsCount: '{count} تذاكر',
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم',
    total: 'الإجمالي',
    backEvents: 'العودة إلى الفعاليات',
    starts: 'تبدأ',
    ends: 'تنتهي',
    organizedBy: 'التنظيم',
    spotsLeft: 'متبقي {count}',
    eventDetails: 'تفاصيل الفعالية',
    location: 'الموقع',
    locationMissing: 'إحداثيات الموقع غير متوفرة',
    category: 'الفئة',
    seating: 'المقاعد',
    loadingMap: 'جارٍ تحميل خريطة المقاعد…',
    priceFrom: 'السعر ابتداءً من',
    selectTickets: 'اختر التذاكر',
    pleaseWait: 'يرجى الانتظار…',
    left: 'متبقي {count}',
    soldOut: 'نفدت',
    addOn: 'إضافة',
    proceed: 'المتابعة للدفع',
    processing: 'جارٍ المعالجة...',
    ticketCount: '{count} تذاكر',
    ticketOne: 'تذكرة واحدة',
    chargedIn: 'سيتم الخصم بعملة {currency}.',
    approxRate: 'سعر تقريبي حسب سعر اليوم.',
    gaZone: 'منطقة عامة',
    valet: 'خدمة صف السيارات',
    timeLeft: 'متبقي {time}',
    spotsLeft: 'متبقي {count}',
    tapToAdd: 'اضغط للإضافة',
    availableCount: '{count} متاح',
    clickSeats: 'اضغط لاختيار المقاعد',
    available: 'متاح',
    held: 'محجوز مؤقتًا',
    sold: 'مباع',
    blocked: 'محظور',
    disabled: 'غير متاح',
    operatedBy: 'تُشغّله {name}، {address}.',
    lastUpdated: 'آخر تحديث 2 أكتوبر 2026',
    customerTerms: 'شروط العملاء',
    status_paid: 'مدفوع',
    status_pending: 'قيد الانتظار',
    status_failed: 'فشل',
    status_cancelled: 'ملغى',
    status_refunded: 'مسترد',
  },
};

export default messages;
